import { render, staticRenderFns } from "./CardRegionItem.vue?vue&type=template&id=3fc24b1e"
import script from "./CardRegionItem.vue?vue&type=script&lang=js"
export * from "./CardRegionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports